import React from 'react';
import {makeStyles} from 'tss-react/mui';
import {FormattedMessage} from 'react-intl';
import {Breakpoints as breakpoints} from 'wobi-web-common';
import {agentDeveloperUtils} from 'wobi-web-common/dist/components/utils/helpers';
import {getImageByAgent} from '../../../config/agent';
import whatsappIcon from '../../../assets/whatsapp-icon.svg';
import {withRouter} from 'react-router-dom';

const companyLogo = getImageByAgent('companyLogo.svg');

const useStyles = makeStyles()((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 20px',
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    position: 'sticky',
    top: 0,
    zIndex: 100,
    [`@media screen and (min-width: ${breakpoints.mobile}px)`]: {
      padding: '16px 40px',
    },
  },
  logo: {
    height: 36,
    [`@media screen and (min-width: ${breakpoints.mobile}px)`]: {
      height: 44,
    },
  },
  whatsappButton: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    backgroundColor: '#25D366',
    color: '#fff',
    border: 'none',
    borderRadius: 20,
    padding: '8px 16px',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
    fontFamily: 'Ploni, Arial, sans-serif',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#1da851',
    },
  },
  whatsappIcon: {
    width: 20,
    height: 20,
  },
}));

const MinimalHeader = () => {
  const {classes} = useStyles();
  const whatsAppNumber = agentDeveloperUtils.websiteConfig?.whatsAppNumber || '9720506565902';
  const whatsappLink = `https://wa.me/${whatsAppNumber}`;
  const displayName = agentDeveloperUtils.agentData?.Display_Name__c || 'Wobi';

  return (
    <header className={classes.header}>
      <a
        href={whatsappLink}
        target='_blank'
        rel='noopener noreferrer'
        className={classes.whatsappButton}
      >
        <img src={whatsappIcon} alt='' className={classes.whatsappIcon} />
        <FormattedMessage id='docCollection.header.whatsapp' />
      </a>
      <img
        src={companyLogo}
        alt={displayName}
        className={classes.logo}
        onError={(e) => {
          e.target.onerror = null;
          e.target.alt = displayName;
        }}
      />
    </header>
  );
};

export default withRouter(MinimalHeader);
